/* eslint-disable max-len */

export default {
  steps: ['/', '/step2', '/step3', '/step4', '/step5'],
  tooltip: {
    '/': 'The customer selects cryptocurrency as the deposit method',
    '/step2': 'The customer selects Bitcoin as the deposit method',
    '/step3': 'The customer confirms the deposit amount in their base currency (in this case, Euros).',
    '/step4': 'Our API automatically creates an invoice at a locked-in exchange rate. The customer can then pay by scanning the QR code, which pre-fills the amount and destination address in their bitcoin wallet, or by using the bitcoin address presented',
    '/step5': 'Success - once the bitcoin have been received, we instantly credit the funds to your Cryptopay account'
  },

  prevStep(currentStep) {
    let currStepIndex = this.steps.indexOf(currentStep);
    if (currStepIndex <= 0) {
      return '';
    }

    return this.steps[currStepIndex - 1];
  },

  nextStep(currentStep) {
    let currStepIndex = this.steps.indexOf(currentStep);
    if (currStepIndex < 0 || currStepIndex === this.steps.length - 1) {
      return '';
    }

    return this.steps[currStepIndex + 1];
  },

  tooltipText(currentStep) {
    return this.tooltip[currentStep];
  }
};



// WEBPACK FOOTER //
// ./src/utils/browserHistory.js